import request from "@/utils/http";

export function orderQuery(params = {}) {
  return request({
    url: '/Qianmi/orderQuery',
    method: 'get',
    params
  })
}